<div class="h-100 box d-flex flex-column px-2 pb-5 relative">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-mission-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div class="py-4 px-4 relative inner h-100">
            <div class="text-s font-semi-bold mb-4">{{ 'v3-byoc-popup-create-mission-position-title' | translate }}</div>

            <div class="border border-dark rounded relative p-4">
                <ng-container *ngIf="loaded">
                    <div class="d-flex align-items-center mb-4">
                        <app-achievement-icon class="icon icon-xxxl icon-achievement me-2"></app-achievement-icon>
                        <div class="text-s font-bold text-uppercase me-auto">{{ missionName }}</div>
                    </div>

                    <div class="ps-6">
                        <app-byoc-mission-step-list #list (loadedList)="listLoaded($event)"></app-byoc-mission-step-list>
                    </div>
                </ng-container>

                <div *ngIf="!loaded" class="py-6">
                    <app-loader loaderType="cover" overlayColor="white"></app-loader>
                </div>
            </div>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center px-4">
        <button (click)="cancelClick()" class="btn btn-primary" translate>v3-button-cancel</button>
        <button (click)="backClick()" class="btn btn-primary ms-auto me-2" translate>v3-button-back</button>
        <button [disabled]="!loaded || !loadedList" (click)="saveClick()" class="btn btn-secondary" [class.btn-disabled]="!loaded || !loadedList" translate>
            v3-button-save
        </button>
    </div>

    <app-loader *ngIf="saving" loaderType="cover" overlayColor="white"></app-loader>
</div>
